import { render } from "./createPublicPersonStepConjuge.vue?vue&type=template&id=6649a87e&scoped=true"
import script from "./createPublicPersonStepConjuge.vue?vue&type=script&lang=js"
export * from "./createPublicPersonStepConjuge.vue?vue&type=script&lang=js"

import "./createPublicPersonStepConjuge.vue?vue&type=style&index=0&id=6649a87e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6649a87e"]])

export default __exports__